var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.config.frame_less.includes(_vm.$route.path))?_c('v-app',[_c('router-view')],1):_c('v-app',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }